// extracted by mini-css-extract-plugin
export default {"toggleButtonAssoc":"ObjAssoc_toggleButtonAssoc__5tmj1","objAssoc":"ObjAssoc_objAssoc__1TtIO","taglabel":"ObjAssoc_taglabel__vth8u"};